var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _rect, _rect2, _rect3, _rect4, _rect5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBot9(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 82,
    width: 152,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9809 86.9141C14 88.8393 14 91.3595 14 96.4V111.6C14 116.64 14 119.161 14.9809 121.086C15.8438 122.779 17.2206 124.156 18.9141 125.019C20.8393 126 23.3595 126 28.4 126H35.6C40.6405 126 43.1607 126 45.0859 125.019C46.7794 124.156 48.1562 122.779 49.0191 121.086C50 119.161 50 116.64 50 111.6V96.4C50 91.3595 50 88.8393 49.0191 86.9141C48.1562 85.2206 46.7794 83.8438 45.0859 82.9809C43.1607 82 40.6405 82 35.6 82H28.4C23.3595 82 20.8393 82 18.9141 82.9809C17.2206 83.8438 15.8438 85.2206 14.9809 86.9141ZM130.981 86.9141C130 88.8393 130 91.3595 130 96.4V111.6C130 116.64 130 119.161 130.981 121.086C131.844 122.779 133.221 124.156 134.914 125.019C136.839 126 139.36 126 144.4 126H151.6C156.64 126 159.161 126 161.086 125.019C162.779 124.156 164.156 122.779 165.019 121.086C166 119.161 166 116.64 166 111.6V96.4C166 91.3595 166 88.8393 165.019 86.9141C164.156 85.2206 162.779 83.8438 161.086 82.9809C159.161 82 156.64 82 151.6 82H144.4C139.36 82 136.839 82 134.914 82.9809C133.221 83.8438 131.844 85.2206 130.981 86.9141Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_47)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 66,
    width: 180,
    height: 76,
    fill: "#7CB342"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 104,
    width: 180,
    height: 38,
    fill: "black",
    fillOpacity: 0.1
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 22C61.2386 22 59 24.2386 59 27V40H53C51.8954 40 51 40.8954 51 42V52H59H75H83H99H107H123H131V42C131 40.8954 130.105 40 129 40H123V27C123 24.2386 120.761 22 118 22H112C109.239 22 107 24.2386 107 27V40H99V27C99 24.2386 96.7614 22 94 22H88C85.2386 22 83 24.2386 83 27V40H75V27C75 24.2386 72.7614 22 70 22H64Z",
    fill: "#E1E6E8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_0_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 51,
    y: 22,
    width: 80,
    height: 30
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64 22C61.2386 22 59 24.2386 59 27V40H53C51.8954 40 51 40.8954 51 42V52H59H75H83H99H107H123H131V42C131 40.8954 130.105 40 129 40H123V27C123 24.2386 120.761 22 118 22H112C109.239 22 107 24.2386 107 27V40H99V27C99 24.2386 96.7614 22 94 22H88C85.2386 22 83 24.2386 83 27V40H75V27C75 24.2386 72.7614 22 70 22H64Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_0_47)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 52,
    fill: "#607D8B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 41,
    width: 100,
    height: 40,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 65,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 113,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "white",
    fillOpacity: 0.6
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "#0076DE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_0_47",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 130,
    height: 120
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 62C25 52.0589 33.0589 44 43 44H137C146.941 44 155 52.0589 155 62V89.1483C155 93.6831 154.229 98.1848 152.72 102.461L135.239 151.991C132.699 159.187 125.896 164 118.265 164H61.7353C54.1036 164 47.3014 159.187 44.7614 151.991L27.2804 102.461C25.7711 98.1848 25 93.6831 25 89.1483L25 62Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_0_47)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 42,
    width: 134,
    height: 124,
    fill: "#9CCC65"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 130,
    width: 27,
    height: 8,
    rx: 4,
    fill: "black",
    fillOpacity: 0.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 48,
    transform: "translate(38 76)",
    fill: "#9F9F9F"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 88,
    width: 104,
    height: 32,
    rx: 16,
    fill: "black",
    fillOpacity: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 98,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 98,
    width: 10,
    height: 12,
    rx: 2,
    fill: "#F4F4F4"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBot9);
export default __webpack_public_path__ + "static/media/bot-9.778d6f092ca7badaf8cb051606e09185.svg";
export { ForwardRef as ReactComponent };